module.exports = __webpack_public_path__ + "img/cancel-icon.606c2543.svg";